<template>
  <div>
    <div
      v-for="(item,index) in orderList"
      :key="index"
      @click="toDetail(item)"
    >
      <div v-show="item.orderType==11007">
        <van-cell>
          <div class="font20 font-bold main-color">
            待入住
          </div>
          {{ item.rzrxm }}  {{ item.rzrq }} {{ item.cityName }}
        </van-cell>
        <van-cell>
          <van-row
            type="flex"
            align="center"
          >
            <van-col span="6">
              <img src="">
            </van-col>
            <van-col
              span="18"
              class="text-left"
            >
              <div>{{ item.jdmc }}</div>
              <div>{{ item.address }}</div>
              <div>{{ item.rzrq }}入住  {{ item.ldrq }}离店</div>
            </van-col>
          </van-row>
        </van-cell>
      </div>
      <div v-if="item.orderType==11001||item.orderType==11004">
        <van-cell>
          <div class="font20 font-bold main-color">
            待出行
          </div>
          {{ item.psgName }}  {{ item.orderRangeBeanList[0].departDate }} {{ item.orderRangeBeanList[0].departCityName }}
        </van-cell>
        <van-cell>
          <van-row
            type="flex"
            align="center"
          >
            <van-col span="8">
              <div class="font16">
                {{ item.orderRangeBeanList[0].departCityName }}
              </div>
              <div class="font24 font-bold">
                {{ item.orderRangeBeanList[0].departTime }}
              </div>
              <div class="gray">
                {{ item.orderRangeBeanList[0].departAirportName }}
              </div>
            </van-col>
            <van-col
              span="8"
              class="text-center"
            >
              <img :src="tk_link">
            </van-col>
            <van-col
              span="8"
              class="text-right"
            >
              <div class="font16">
                {{ item.orderRangeBeanList[0].arriveCityName }}
              </div>
              <div class="font24 font-bold">
                {{ item.orderRangeBeanList[0].arriveTime }}
              </div>
              <div class="gray">
                {{ item.orderRangeBeanList[0].arriveAirportName }}
              </div>
            </van-col>
          </van-row>
        </van-cell>
      </div>
      <div v-show="item.orderType==11009">
        <van-cell>
          <div class="font20 font-bold main-color">
            待出行
          </div>
          {{ item.passengerNames }}  {{ item.fromDate }} {{ item.fromTime }} {{ item.fromWeek }}
        </van-cell>
        <van-cell>
          <van-row
            type="flex"
            align="center"
          >
            <van-col span="8">
              <div class="font16">
                {{ item.fromCityName }}
              </div>
              <div class="font24 font-bold">
                {{ item.fromTime }}
              </div>
              <div class="gray">
                {{ item.fromStationName }}
              </div>
            </van-col>
            <van-col
              span="8"
              class="text-center"
            >
              <img :src="tr_link">
            </van-col>
            <van-col
              span="8"
              class="text-right"
            >
              <div class="font16">
                {{ item.toCityName }}
              </div>
              <div class="font24 font-bold">
                {{ item.toTime }}
              </div>
              <div class="gray">
                {{ item.toStationName }}
              </div>
            </van-col>
          </van-row>
        </van-cell>
      </div>
    </div>
  </div>
</template>
<script>
import { Cell } from 'vant'
export default {
  name:'',
  components:{
    [Cell.name]:Cell
  },
  data(){
    return {
      orderList:[]
    }
  }
}
</script>
<style lang="less" scoped>

</style>